import { createStore } from 'vuex'

export default createStore({
  state: {
    msgNum:0
  },
  getters: {
    getMsgNum:(state)=>{
      // console.log('get store:',state.msgNum)
      return state.msgNum
    }
  },
  mutations: {
    updateMsgNum2(state,newValue){
      // console.log('mutation store new val:',newValue)
      state.msgNum = newValue
    }
  },
  actions: {
    updateMsgNum(context,newValue){
      // console.log('action store new val:',newValue)
      context.commit('updateMsgNum2',newValue)
    }
  },
  modules: {
  }
})

